module.exports = "pegasus_template/assets/tech/basic_2/1.png";